import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./layouts/Main";
import NotFound from "./pages/NotFound";
import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";
import { AuthProvider } from "./context/AuthContext";

// Import CSS/SCSS
import "./assets/css/remixicon.css";
import "./scss/style.scss";
import "./assets/css/customScrollbar.css";
import ProtectedRoute from "./components/protectedRoutes";
import { MediaSocketProvider } from "./context/ChatContext";
import { DashboardProvider } from "./context/dashboardContext";
import { LabProvider } from "./context/labContext";
import { VitalsProvider } from "./context/vitalsContext";
import { DrugsProvider } from "./context/manageDrugs";
import { BillsProvider } from "./context/paymentAndBillsContext";
 
// Set skin mode on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");
  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode);
  }
});
 
export default function App() {
  return (
    <AuthProvider>
      <DashboardProvider>
        <LabProvider>
          <VitalsProvider>
            <DrugsProvider>
              <BillsProvider>
                <MediaSocketProvider>
                <BrowserRouter>
                  <Routes>
                    <Route  element={<Main />}>
                      {/* Protected Routes */}
                      <Route element={<ProtectedRoute />}>
                        {protectedRoutes.map((route, index) => (
                          <Route path={route.path} element={route.element} key={index} />
                        ))}
                      </Route>
                    </Route>

                    {/* Public Routes */}
                    {publicRoutes.map((route, index) => (
                      <Route path={route.path} element={route.element} key={index} />
                    ))}

                    {/* Not Found Page */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </BrowserRouter>
                </MediaSocketProvider>
              </BillsProvider>
            </DrugsProvider>
          </VitalsProvider>
        </LabProvider>
      </DashboardProvider>
    </AuthProvider>
  );
}
